/* eslint-disable no-nested-ternary */
import React from 'react';
import { FormattedMessage } from 'react-intl';
import { get } from 'lodash';
import InboxTransitionBase from './InboxTransitionBase';
import { getFirstName } from '../../util/user';

const InboxTransitionRequestExpiresSoon = ({
  transition,
  provider,
  customer,
  ownRole,
  listingTitle,
  buttons,
  earnings,
  remainingTimeFormat,
}) => {
  const isCustomer = ownRole === 'customer';
  const customerDisplayName = getFirstName(get(customer, 'attributes.profile.displayName', ''));
  const providerDisplayName = getFirstName(get(provider, 'attributes.profile.displayName', ''));

  return (
    <InboxTransitionBase
      date={transition.createdAt}
      direction="left"
      header={
        isCustomer ? (
          <FormattedMessage
            id="BookingStatus.ownTransitionRequest"
            values={{ authorDisplayName: providerDisplayName }}
          />
        ) : (
          <FormattedMessage
            id="BookingStatus.transitionRequest"
            values={{ displayName: customerDisplayName, listingTitle }}
          />
        )
      }
      buttons={buttons}
      buttonsTitle={
        <FormattedMessage
          id="BookingStatus.ownTransitionRequestButtonTitle"
          values={{
            timer: remainingTimeFormat,
          }}
        />
      }
    >
      {isCustomer ? (
        <FormattedMessage id="BookingStatus.ownTransitionRequestSubtext" />
      ) : earnings ? (
        <FormattedMessage id="BookingStatus.transitionRequestSubtext" values={{ earnings }} />
      ) : null}
    </InboxTransitionBase>
  );
};

export default InboxTransitionRequestExpiresSoon;
